<template>
  <div :class="{ 'board-scrolled': detectDownScrollTrigger }">
    <MoreProduct
      :products="products as IProduct[]"
      @click-product="onClickProduct"
      @click-search="goToSearch"
    ></MoreProduct>
  </div>
</template>

<script setup lang="ts">
const { products } = storeToRefs(useProductStore())
const { message } = useAlarm()
const {
  public: { productUrl }
} = useRuntimeConfig()

definePageMeta({
  layout: 'center'
})

const { ogUrl, ogTitle } = useSeo()

useSeoMeta({
  title: '전세계 상품보기',
  description: '일본, 대만, 아시아, 미국, 캐나다, 유럽 34개국 등 세계 여러 나라를 여행해 보세요.',
  ogType: 'website',
  ogUrl: () => ogUrl('product/more'),
  ogTitle: () => ogTitle('전세계 상품보기'),
  ogDescription: '일본, 대만, 아시아, 미국, 캐나다, 유럽 34개국 등 세계 여러 나라를 여행해 보세요.',
  twitterCard: 'summary',
  twitterTitle: () => ogTitle('전세계 상품보기'),
  twitterDescription:
    '일본, 대만, 아시아, 미국, 캐나다, 유럽 34개국 등 세계 여러 나라를 여행해 보세요.',
  keywords:
    '일본, 대만, 태국, 필리핀, 중국, 유럽, 미국, 호주, 괌/사이판, UAE, eSIM, USIM, 일본eSIM, 대만eSIM, 태국eSIM, 필리핀eSIM, 중국eSIM, 유럽eSIM, 미국eSIM, 호주eSIM, 괌/사이판eSIM, UAEeSIM, 일본USIM, 대만USIM, 태국USIM, 필리핀USIM, 중국USIM, 유럽USIM, 미국USIM, 호주USIM, 괌/사이판USIM'
})

const detectDownScrollTrigger = ref<boolean>(false)

const onClickProduct = (product?: IProduct) => {
  if (product) {
    navigateTo(`${productUrl}/sim/${product.productId}`, { external: true })
  } else {
    message('info', '판매중인 상품이 아니에요.', false, false, 2000, 90, 'message-plain')
  }
}

const goToSearch = () => navigateTo('/search')
</script>
